import { createSlice } from '@reduxjs/toolkit';

import { LOGOUT } from '../../constants/actions/auth.constants';
import { createAppAsyncThunk } from '../../reducers/createAppAsyncThunk';
import type { AppState } from '../../reducers/root.reducer';
import ImpersonationService from '../services/ImpersonationService';

const NAME = 'Impersonation';

export type ImpersonationState = {
    userId: number | null;
};

const start = createAppAsyncThunk(
    `${NAME}/start`,
    async (primaryAdminId: number) => {
        ImpersonationService.setUserId(primaryAdminId);
        return primaryAdminId;
    },
);

const end = createAppAsyncThunk(`${NAME}/end`, async () => {
    ImpersonationService.clear();
});

const slice = createSlice({
    name: NAME,
    initialState: (): ImpersonationState => ({
        userId: ImpersonationService.getUserId(),
    }),
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(start.fulfilled, (state, action) => {
            state.userId = action.payload;
        });
        builder.addCase(end.fulfilled, (state) => {
            state.userId = null;
        });
        // UserService.logout clears the persisted id together with the tokens
        builder.addCase(LOGOUT, (state) => {
            state.userId = null;
        });
    },
});

const getUserId = (state: AppState) => state.common.impersonation.userId;

const ImpersonationSlice = {
    actions: { start, end },
    reducer: slice.reducer,
    state: {
        getUserId,
        isImpersonating: (state: AppState) => getUserId(state) !== null,
    },
};

export default ImpersonationSlice;
